// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { DocumentTypeCodeDescription } from '@quromedical/fhir-common';
import { AsyncDownloadButton } from 'components/input';
import { ColumnType } from 'components/table';
import { getDisplayDate } from 'core/display';
import { DocumentApi } from 'integration/aggregate';
import { strings } from 'strings';

export interface DocumentTable {
  id: string;
  title: string;
  type: string;
  status: string;
  author: string;
  date: string;
}

const api = new DocumentApi();

const fetchUrl = (documentId: string) => async (): Promise<string> => {
  if (!documentId) {
    return undefined;
  }

  return await api.getDownloadURL(documentId);
};

export const createDocumentColumns = (): ColumnType<DocumentTable>[] => [
  {
    header: strings.DocumentType,
    accessor: 'type',
    Cell: value => DocumentTypeCodeDescription[value.row.original.type],
  } as ColumnType<DocumentTable, 'type'>,
  {
    header: strings.DocumentDate,
    accessor: 'date',
    Cell: value => getDisplayDate(value.row.original.date),
  } as ColumnType<DocumentTable, 'date'>,
  {
    header: strings.DocumentAuthor,
    accessor: 'author',
  } as ColumnType<DocumentTable, 'author'>,
  {
    header: strings.MediaDownloadButtonText,
    Cell: ({ row }) => (
      <AsyncDownloadButton fetchUrl={fetchUrl(row.original.id)} title={strings.DocumentDownload} />
    ),
    accessor: 'document',
  } as ColumnType<DocumentTable, 'document'>,
];
